import {
  Box,
  Button,
  Heading,
  IconButton,
  Link,
  Stack,
  Table,
} from "@chakra-ui/react";
import { useInvoiceTemplateList } from "../../../hooks/useInvoiceTemplateList";
import { Link as ReactRouterLink } from "react-router-dom";
import { Plus, Pencil } from "lucide-react";

const InvoiceTemplates = () => {
  const { data, isLoading } = useInvoiceTemplateList();

  return (
    <>
      <Stack direction="row">
        <Link asChild>
          <ReactRouterLink to="/invoices/templates/create/">
            <Button variant="solid" colorPalette="blue">
              Lag ny mal <Plus />
            </Button>
          </ReactRouterLink>
        </Link>
      </Stack>
      <Table.ScrollArea>
        <Table.Root>
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>Malnummer</Table.ColumnHeader>
              <Table.ColumnHeader>Navn</Table.ColumnHeader>
              <Table.ColumnHeader>Utsendingstype</Table.ColumnHeader>
              <Table.ColumnHeader>Forfallsdager</Table.ColumnHeader>
              <Table.ColumnHeader>Handlinger</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {!isLoading &&
              data?.map((template) => (
                <Table.Row key={template.id}>
                  <Table.Cell>{template.id}</Table.Cell>
                  <Table.Cell>{template.name}</Table.Cell>
                  <Table.Cell>{template.deliveryType}</Table.Cell>
                  <Table.Cell>{template.dueDays}</Table.Cell>
                  <Table.Cell>
                    <Link asChild>
                      <ReactRouterLink
                        to={`/invoices/templates/${template.id}/edit/`}
                      >
                        <IconButton
                          size="lg"
                          colorPalette="blue"
                          variant="ghost"
                          aria-label="Endre"
                        >
                          <Pencil />
                        </IconButton>
                      </ReactRouterLink>
                    </Link>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table.Root>
      </Table.ScrollArea>
    </>
  );
};

export default function InvoiceTemplatesPage() {
  return (
    <Box>
      <Heading as="h1" mb={4}>
        Fakturamaler
      </Heading>
      <InvoiceTemplates />
    </Box>
  );
}
